// extracted by mini-css-extract-plugin
export default {"logoWrapper":"DetailsPane_logoWrapper__5HCLb","header":"DetailsPane_header__TT378","title":"DetailsPane_title__3O0KA","collapseAll":"DetailsPane_collapseAll__XgL4X"};